module.exports = __webpack_public_path__ + "img/grouping-dude-without-suggestions.211b4974.svg";